var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content" },
    [
      _c("sales-query-tree-grid", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.view === "list",
            expression: "view==='list'"
          }
        ],
        ref: "salesQueryTreeGrid",
        attrs: {
          context: _vm.context,
          "is-sales-for-szfs": _vm.isSalesForSzfs
        },
        on: { look: _vm.lookHandle }
      }),
      _c("sales-query-workspace", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.view === "detail",
            expression: "view==='detail'"
          }
        ],
        ref: "salesQueryWorkspace",
        attrs: {
          "parent-context": _vm.context,
          "is-sales-for-szfs": _vm.isSalesForSzfs
        },
        on: { back: _vm.backToList }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }